import * as React from 'react';
import { Permission, MeatballMenu, PromptConfirmationModal, DisplayCodes } from 'ui';
import { ButtonTertiary } from 'ui/common/button/button-tertiary';
import { DialogExpander } from 'ui/common/dialog-expander/dialog-expander';
import { MdKeyboardArrowDown } from 'react-icons/md';
import styles from './code-title-tile.scss';
import { TileProps } from 'ui/tile/tile';
import { ExpanderBackground } from 'ui/common/dialog-expander/expander-background/expander-background';
import { ValidationLevel } from 'ui/common';
import { DisplayTextWithLinks } from 'ui/common/display-text-with-links';

export class CodeTitleTile extends React.PureComponent<TileProps, any> {

  public static defaultProps: Partial<TileProps> = {
    enabledChildEntityOperations: { remove: false }
  };

  private handleSelect = (e?: any) => {
    e && e.preventDefault();

    this.props.onSelectDocumentItem && this.props.onSelectDocumentItem();
  };

  private handleDeselect = (e?: any) => {
    e && e.preventDefault();

    if (this.props.activate) {
      this.props.onSelectDocumentItem && this.props.onSelectDocumentItem(null);
    }
  };

  private handleDelete = (e?: any) => {
    e && e.preventDefault();
    this.props.onDeleteDocumentItem && this.props.onDeleteDocumentItem();
  };

  private hasChildErrors () {
    const {validationDescendants} = this.props;
    return validationDescendants && validationDescendants.length && validationDescendants.some(v => v.level === ValidationLevel.error);
  }

  private hasChildWarnings() {
    const {validationDescendants} = this.props;
    return validationDescendants && validationDescendants.length && validationDescendants.some(v => v.level === ValidationLevel.warning);
  }

  private getDetailsButtonStyle = () => (
        this.hasChildErrors() ?
        styles.hasChildErrors :
        (this.hasChildWarnings() ? styles.hasChildWarnings : ''));

  public render() {
    const {
      componentId, primaryKey, details, children, activate,
      showPrimaryKey = true,
      showPrimaryKeyLongDescription = true,
      linkifyLongDescription = true,
      showDetailsButton = true,
      textShowDetails, textHideDetails, textDone, className, expandAll
    } = this.props;
    const { codeTitleTile, codeTitleTileCard, header, displayCodes, main } = styles;

    const renderAsOpened = showDetailsButton && activate && details;
    const renderHeader = showPrimaryKey || this.shouldRenderContextMenu();
    const openDetailsHandler = renderAsOpened ? this.handleDeselect : this.handleSelect;
    const activeStyling = renderAsOpened ? styles.activeTile : '';

    const detailsButton = showDetailsButton && details && <ButtonTertiary classNames={`btn-block ${this.getDetailsButtonStyle()}`}
        onClick={openDetailsHandler}>
        {renderAsOpened ? textHideDetails : textShowDetails}
        <MdKeyboardArrowDown/>
      </ButtonTertiary>;

    return (
      <>
        {renderAsOpened ? <div tabIndex={0} onFocus={this.handleDeselect}/> : ''}
        <div className={`${className} ${codeTitleTile} ${activeStyling}`}>
          <div id={componentId} className={codeTitleTileCard}>
            {renderHeader && <div className={header}>
              {showPrimaryKey && <h3>
                <DisplayCodes
                  componentId={`${componentId}-code`}
                  className={displayCodes}
                  valueItems={[primaryKey]}
                  displayIcon={'left'}
                  options={undefined}
                  onChange={undefined}
                />
              </h3>}
              {
                showPrimaryKey && showPrimaryKeyLongDescription && primaryKey.longDescription &&
                  <DisplayTextWithLinks 
                    className={styles.longDescription} 
                    linkify={linkifyLongDescription} 
                    text={primaryKey.longDescription} />
              }
              {this.renderContextMenu()}
            </div>}
            {children && (<div className={`${main} row`}>
              {children}
            </div>)}
            {expandAll && details && <div className="col-12">{details}</div>}
            {!expandAll && detailsButton}

          </div>

          {renderAsOpened && <DialogExpander title={showPrimaryKey ? primaryKey.description : undefined} hasLongDescription={true}
                                            onClose={this.handleDeselect} textDone={textDone}>
                                {details}
                              </DialogExpander>}
          {renderAsOpened && <ExpanderBackground onClick={this.handleDeselect}/>}
        </div>
      </>
    );
  }

  private shouldRenderContextMenu = () => {
    const { enabledChildEntityOperations } = this.props;

    return enabledChildEntityOperations && Object.keys(enabledChildEntityOperations)
      .reduce((acc, key) => acc || enabledChildEntityOperations[key], false);
  };

  private renderContextMenu() {

    if  (!this.shouldRenderContextMenu()) {
      return undefined;
    }

    const { enabledChildEntityOperations, textDelete, textDeleteMessage, textContinue, textCancel } = this.props;
    const { tileDropdown } = styles;

    return (
      <Permission requireAny="remove" permissions={enabledChildEntityOperations}>
        <div className={tileDropdown}>
          <MeatballMenu>
              <Permission requireAll="remove" permissions={enabledChildEntityOperations} isListElement={true}>
                <PromptConfirmationModal
                  title={textDelete}
                  description={textDeleteMessage}
                  continueText={textContinue}
                  cancelText={textCancel}
                  onContinue={this.handleDelete}>
                  <button type="button" className="dropdown-item">{textDelete}</button>
                </PromptConfirmationModal>
              </Permission>
          </MeatballMenu>
        </div>
      </Permission>
    );
  }
}
